<template>
  <div class="">
    <!-- <navbar-sas></navbar-sas> -->
    <div class="card m-4 mt-5 p-5">
        <div class="container">
            <div class="row">
            <div class="col-12 d-flex justify-content-between align-items-center mb-3">
                <h3>Administrar Usuarios</h3>
                <button class="btn btn-blue p-2" @click="openAddUSer">
                    <i class="fas fa-user-plus mr-2"></i> Añadir Usuario
                </button>
            </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th>Nombre</th>
                      <th>Usuario</th>
                      <th>Email</th>
                      <th>Rol</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in paginatedUsers" :key="index">
                      <td>{{ user.nombre }}</td>
                      <td>{{ user.usuario }}</td>
                      <td>{{ user.correo }}</td>
                      <td>{{ user.descripcion }}</td>
                      <td>
                        <button
                          class="btn btn-info btn-sm mr-2"
                          @click="editUser(user)"
                          style="border-radius: 8px;"
                          :disabled="user.activo == false"
                        >
                          <i class="fas fa-edit mr-1"></i> Editar
                        </button>
                        <button
                          :class="user.activo ? 'btn btn-danger btn-sm' : 'btn btn-success btn-sm'"
                          style="border-radius: 8px;"
                          @click="openModalEliminar(user, user.activo ? false : true, user.activo ? 'Desactivar' : 'Activar')"
                        >
                          <i class="fas fa-power-off mr-1"></i> {{ user.activo ? 'Desactivar' : 'Activar' }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <nav>
                  <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
                    </li>
                    <li
                      class="page-item"
                      v-for="page in totalPages"
                      :key="page"
                      :class="{ active: currentPage === page }"
                    >
                      <button class="page-link" @click="changePage(page)">{{ page }}</button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
        </div>
    </div> 
    <div class="foot"> 
        <p>&copy; 2024 Latino Seguros.</p>
    </div>

    <agregarUserModal
    @formularioCompletado="manejarFormulario"
    :cleanModal="false"
    ref="addUSer"/>

    <EditarUsuarioModal
    @field-changed="handleFieldChange"
    :editarUsuario="editarUsuario"
    :nombre.sync="usuarioFull.nombre"
    :email.sync="usuarioFull.email"
    :user.sync="usuarioFull.user"
    :password.sync="usuarioFull.password"
    :confirmPassword.sync="usuarioFull.confirmPassword"
    :rol.sync="usuarioFull.rol"
    ref="editUser"/>
    
    <ErrorModal
    :errorMessage="errorMessage"/>

    <SuccessModal
    :successrMessage="successMessage"/>

    <EliminarUsuarioModal
    :changeUser="updateStatusUser"
    :accion="accion"
    :usuario="usuarioActive"/>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script>
import NavbarSas from './navbarSas.vue'; 
import Loading from '../../componentes/ImgLoading/loading.vue'
import agregarUserModal from "./Modals/agregarUserModal.vue";
import EditarUsuarioModal from "./Modals/editarUsuarioModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import SuccessModal from "./Modals/successModal.vue";
import EliminarUsuarioModal from "./Modals/eliminarUsuarioModal.vue";
import axios from 'axios';
import { getBaseUrl } from '../../store/actions/ModuloActions';

export default {
    components: {
      Loading, 
      NavbarSas,
      agregarUserModal,
      ErrorModal,
      SuccessModal,
      EditarUsuarioModal,
      EliminarUsuarioModal
    },
    data() {
    return {
      usuarioSAS: {
          userName: "900650",
          password: "123456",
        },
      showModal: false,
      isEditing: false,
      errorMessage: '',
      successMessage: '',
      idaplicacion: '',
      accion: '',
      active: '',
      usuarioActive: '',
      encryptPasswword: '',
      form: {
        id: null,
        name: "",
        email: "",
        role: "user",
      },
      datosFormularios: {},
      usuarioFull: {
        nombre: '',
        email: '',
        user: '',
        password: '',
        confirmPassword: '',
        rol: 0,
      },
      users: [],
      currentPage: 1,
      itemsPerPage: 10,
      dataUsuario: [],
      isLoading: false,
    };
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    async openAddUSer(){
      this.$modal.show('add-user')
      await this.getRol();
    },
    async getUsuarios() {
      this.loading = true;
      let usuarios = []
      var config = {
        method: "POST",
        url: `security/api/user/getUsuariosXAplicacion?IdAplicacion=26&IdUsuario=${localStorage.getItem('profileId')}`,
        headers: {
          "Content-Type": "application/json",
          XAPPID: this.$store.state.config.headers.XAPPID,
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        data: {}
      };
      await axios(config)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.flag) {
              usuarios = response.data.data
              console.log(usuarios);
            }
          } else {
            console.log('error');
          }
        })
        this.users = usuarios
    },
    async manejarFormulario(datosFormularios) {
      console.log(datosFormularios);
      this.isLoading = true;
        this.datosFormularios = datosFormularios // Manejar los datos recibidos del formulario hijo
        const payload = {
          metodo: "REGISTROUSUARIO",
          data: {
            Usuario: {
                IdSexo: 0,
                IdTipoPersona: 0, //1 PERSONA FÍSICA , 2PERSONA MORAL
                IdEstadoCivil: 0,
                IdArea: 47,
                IdTipoUsuario: 2,
                IdUsuarioApp: "",  //no se manda
                Nombre: this.datosFormularios.Nombre,  //para razon socialtodo sobre el nombre
                Apaterno: "",
                Amaterno: "",
                Usuario: this.datosFormularios.Usuario,
                Password: this.datosFormularios.Password,
                ConfirmacionPassword: this.datosFormularios.ConfirmPassword,
                RutaFoto: "",
                Activo: 1,
                IdRool: this.datosFormularios.Rol,
                RFC: '',
                IdAplicacion:"26"
            },
            DomicilioUsuario: [
                { //lista de domicilio
                    Calle: null,
                    NumExterior: null,
                    NumInterior: null,
                    IdEstado: 0,
                    Estado: null,
                    IdMunicipio: 0,
                    Municipio: null,
                    IdColonia: 0,
                    Colonia: null,
                    Cp: null
                }
            ],
            ContactoUsuario: [ //lista de contacto
                {
                    TIPOCONTACTO: 3, //- 1    TELÉFONO PRINCIPAL  2 TELÉFONO ECUNDARIO 3 CORREO ELECTRÓNICO
                    VALOR: this.datosFormularios.Email
                }
            ],
            Validaciones: {
                ValidaEmail: true,
                ValidaRfc: true,
                ValidaPassIgual: true,
                AplicaSeguridadPassword: false,
                ValidaCondiciones: true,
                GeneraPassword: false,
                ValidaGeneraCorreoConPass: false,
                ValidaGeneraCodigoVerificador: false
            },
            DatosProveedor: {
              DatosGenerales: {
                  IDTITULO: 0,
                  IDPRODUCCIONECONOMICA: 0, 
                  IDONBASE: "",
                  IDSISE: "",
                  IDINVITACION: "",
                  TIPOPERSONA: "", 
                  IDOCUPACIONPROF: 0,
                  OCUPACIONPROF: "",
                  ESTADOCIVIL: "",
                  SEXO: "",
                  IDNACIONALIDAD: 0, 
                  NACIONALIDAD: "",
                  IDPAIS: 0,
                  PAIS: "",
                  FECHANAC: "1900-01-01",
                  LUGARNAC: "",
                  CURP: "",
                  NOMBRECORTO: ''
              }
            }
          },
          };
          console.log(payload);
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
              const res = this.$store.getters.getRespuestaREST;
              if (res != "") {
                this.successMessage = 'Usuario registrado exitosamente.'
                this.$modal.hide('add-user');
                this.$modal.show('success-modal');
                this.getUsuarios()
              }
              console.log(res);
            } else {
              this.errorMessage = this.$store.getters.getDataRaw.errorMessage
              this.$modal.show('error-modal');
            }
          } //Fin try
          catch (error) {
              console.log(error);
          }
          this.isLoading = false;
    },
    async getRol() {
        this.isLoading = true;
        const payload = {
          metodo: "GETAPPPORROLSAS",
          data: { }
          };
          
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
              const res = this.$store.getters.getRespuestaREST;
              if (res != "") {
                res.map( (data, i) => {
                  if(data.descripcion == 'ANALISTA') { this.idaplicacion = data.idrol;}
                  // if(data.descripcion == 'ADMINISTRADOR') { this.idaplicacion = data.idrol;}
                })
              }
            } else {
            }
          } //Fin try
          catch (error) {
              console.log(error);
          }
          this.isLoading = false;
    },
    async editUser(user){
      this.$modal.show('edit-user');
      this.getUsuariosFull(user)
    },
    async getUsuariosFull(user) {
      this.isLoading = true;
        const payload = {
          metodo: "GETUSERFULL",
          data: {
            usuario: user.usuario,
            tipobusqueda: "2"
           }
          };
          
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
              const res = this.$store.getters.getRespuestaREST;
              console.log(res);
              this.dataUsuario = res
              this.desencriptarPassword(res.usuario.password, '2')
              this.usuarioFull.nombre = res.usuario.nombre
              this.usuarioFull.user = res.usuario.usuario
              this.usuarioFull.rol = res.rolesXUsuario.length >= 2 ? user.idrol : res.rolesXUsuario[0].idrol
              this.usuarioFull.email = res.contactos[0].valor
              console.log(this.usuarioFull.email);
              
            } else {
              this.$modal.hide('edit-user')
              this.errorMessage = this.$store.getters.getDataRaw.errorMessage
              this.$modal.show('error-modal');
            }
          } //Fin try
          catch (error) {
              console.log(error);
          }
          this.isLoading = false;
    },
    async desencriptarPassword(password, tipo){
        this.isLoading = true;
        const payload = {
            metodo: "DECRYPTPASSWORD",
            data: {
              valorin: password,
              valorout: '',
              tipo: tipo
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const res = this.$store.getters.getRespuestaREST;
        if (tipo == '2') {
          this.usuarioFull.password = res.valorout
          this.usuarioFull.confirmPassword = res.valorout
        } else {
          this.encryptPasswword = res.valorout
        }
        })
        this.isLoading = false;
    },
    handleFieldChange({ prop, value }) {
      switch (prop) {
        case 'nombre':
          this.usuarioFull.nombre = value
          break;
        case 'rol':
          this.usuarioFull.rol = value
          if (value == '50152' || value == '50153') {
            this.dataUsuario.usuario.idarea = '47'
          } else {
            this.dataUsuario.usuario.idarea = '7'
          }
          break;
        case 'user':
          this.usuarioFull.user = value
          break;
        case 'password':
          this.usuarioFull.password = value
          break;
        case 'confirmPassword':
          this.usuarioFull.confirmPassword = value
          break;
        case 'email':
          this.usuarioFull.email = value
          break;
        default:
          break;
      }
      console.log(`Propiedad cambiada: ${prop}, Nuevo valor: ${value}`);
    },
    async editarUsuario(){
      if (this.usuarioFull.password != this.usuarioFull.confirmPassword) {
        this.errorMessage = 'Las contraseñas son diferentes'
        this.$modal.show('error-modal');
        return;
      }
      const promise = new Promise((resolve, _) => {
        resolve(this.desencriptarPassword(this.usuarioFull.password, '1'));
      });
      promise.then( async _ => {
        this.isLoading = true;
        setTimeout( async () => {
          const payload = {
            metodo: "UPDATEUSER",
            data: {
                Reglas:
                {
                  IDUSRMODIF: localStorage.getItem('profileId')   //es el id de usuario que modifica
                },
                Usuario: {
                  idusuario: this.dataUsuario.usuario.idusuario,
                  IDAPLICACION: 26,
                  IDSEXO: 0,
                  IDTIPOPERSONA: 0,
                  IDESTADOCIVIL: 0,
                  IDAREA : this.dataUsuario.usuario.idarea,
                  IDTIPOUSUARIO: 7,
                  IDUSUARIOAPP: this.usuarioFull.user,
                  APATERNO: "",
                  AMATERNO: "",
                  NOMBRE: this.usuarioFull.nombre,
                  FECHANACCONST: "",
                  USUARIO: this.usuarioFull.user,
                  PASSWORD: this.encryptPasswword,  //Se manda la contraseña encriptada.
                  RUTAFOTOPERFIL: "../dist/img/user.png",            
                  ACTIVO: true
                },
                domicilios: this.dataUsuario.domicilios,
                /*[
                  {
                    IDDOMICILIO:10078,
                    CALLE:"",
                    NUMEXT:"",
                    NUMINT:"",
                    IDESTADO:"0",
                    ESTADO:"",
                    IDMUNICIPIO:"0",
                    IDCOLONIA:"0",
                    COLONIA:"",
                    CP:""
                  }
                ],*/
                Contactos: //this.dataUsuario.contactos, 
                [
                  {
                    IDCONTACTO: this.dataUsuario.contactos.length > 0 ? this.dataUsuario.contactos[0].idcontacto : null,
                    IDTIPOCONTACTO:"3",
                    VALOR: this.usuarioFull.email,
                    ACTIVO: true
                  }
                ],
                RolesXUsuario: [
                  {
                    IDROLXUSUARIO: this.dataUsuario.rolesXUsuario[0].idrolxusuario,
                    IDROL: this.usuarioFull.rol,
                    IDESTACIONXAPP: 0,  //siempre va en 0
                    IDAPLICACION: "26"
                  }
                ]
            }
            };
            console.log(payload);
              try {
              const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                  const res = this.$store.getters.getRespuestaREST;
                  if (res) {
                    this.getUsuarios()
                    this.$modal.hide('edit-user');
                    this.successMessage = 'Usuario editado exitosamente.'
                    this.$modal.show('success-modal');
                  }
                  console.log(res);
                } else {
                }
              } //Fin try
              catch (error) {
                  console.log(error);
              }
            },1100)
            this.isLoading = false;
      })
    },
    openModalEliminar(user, active, accion){
      this.getUsuariosFull(user)
      this.$modal.show('eliminar-modal')
      this.usuarioActive = user.usuario;
      this.accion = accion
      this.active = active
    },
    async updateStatusUser(){
        console.log(this.dataUsuario.usuario.password);
        this.isLoading = true;
          const payload = {
            metodo: "UPDATEUSER",
            data: {
              Reglas:
              {
                IDUSRMODIF: localStorage.getItem('profileId')   //es el id de usuario que modifica
              },
              Usuario: {
                idusuario: this.dataUsuario.usuario.idusuario,
                IDAPLICACION: 26,
                IDSEXO: 0,
                IDTIPOPERSONA: 0,
                IDESTADOCIVIL: 0,
                IDAREA: this.dataUsuario.usuario.idarea,
                IDTIPOUSUARIO: this.dataUsuario.usuario.idtipousuario,
                IDUSUARIOAPP: this.dataUsuario.usuario.usuario,
                APATERNO: "",
                AMATERNO: "",
                NOMBRE: this.dataUsuario.usuario.nombre,
                FECHANACCONST: "",
                USUARIO: this.dataUsuario.usuario.usuario,
                PASSWORD: this.dataUsuario.usuario.password,  //Se manda la contraseña encriptada.
                RUTAFOTOPERFIL: "../dist/img/user.png",            
                ACTIVO: this.active
              },
            }
            };
            console.log(payload);
            
              try {
              const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                  const res = this.$store.getters.getRespuestaREST;
                  if (res) {
                    this.getUsuarios()
                    this.$modal.hide('eliminar-modal')
                    this.successMessage = 'Usuario editado exitosamente.'
                    this.$modal.show('success-modal');
                  }
                } else {    
                  this.$modal.hide('eliminar-modal')
                  this.errorMessage = this.$store.getters.getDataRaw.errorMessage
                  this.$modal.show('error-modal');
                }
              } //Fin try
              catch (error) {
                  console.log(error);
              }
            this.isLoading = false;
      // })
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.users.length / this.itemsPerPage);
    },
    paginatedUsers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.users.slice(start, end);
    },
  },
  async mounted() {
    await this.$store.dispatch("loginSeguridad", {usuario: this.usuarioSAS});
    setTimeout( () => {
      this.getUsuarios()
    },1000)
    this.isLoading = false;
    // this.$modal.show('eliminar-modal');
  }
};
</script>

<style scoped>
.page-item.disabled .page-link {
  cursor: not-allowed;
}
.page-item.active .page-link {
  background-color: #003c71;
  border-color: #003c71;
  color: white;
}
.page-link {
  cursor: pointer;
}
.foot {
    background-color: #003c71;
    height: 60px;
    margin-top:13%
}
.foot p {
    padding: 20px;
    color: #ffffff;
    text-align: center;
}
.card{
  border-radius: 25px;
  box-shadow: 10px 10px 25px 4px rgba(0,0,0,0.1);
  min-height: 480px;
}
.btn-blue{
    border-radius: 10px;
    background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
    border: #003c71;
    color: white;
}
.table {
  margin-top: 20px;
}
.modal-backdrop {
  z-index: 1040;
}
.modal-content {
  z-index: 1050;
}
</style>